// extracted by mini-css-extract-plugin
export default {"container":"EventInfoDialog_container__v3S8d","title":"EventInfoDialog_title__y9WHy","participantContainer":"EventInfoDialog_participantContainer__ju3TY"};